import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule } from '@angular/http';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { AppRoutingModule } from './app-routing.module';
import { CreateCandidateComponent } from './candidate/create-candidate/create-candidate.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [SidebarComponent , NavbarComponent,CreateCandidateComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    MatAutocompleteModule,
    MatTooltipModule,



  ],
  exports: [SidebarComponent ,NavbarComponent]
})
export class SideNavbarModule { }

export interface INavbarModule {
  name: string;
  route: string;
  icon: string;
  activeClass: string;
}

export interface INavbarService {
  getNavModules: INavbarModule[];
  addNavModule(navModule: INavbarModule): void;
}
